// Measures the bounding client rect of the main content area and keeps it updated
import { useEffect, useState } from "react";

export function useMainContentRect() {
  const [rect, setRect] = useState<DOMRect | null>(null);

  useEffect(() => {
    // Try to locate the main content element; keep the existing structure as a fallback
    const el = (document.querySelector("div.app-layout > main") ||
      document.querySelector("main")) as HTMLElement | null;
    if (!el) return;

    const update = () => setRect(el.getBoundingClientRect());
    update();

    const ro = new ResizeObserver(() => update());
    ro.observe(el);

    // Also listen to window resize in case layout shifts outside of the element's own resize
    window.addEventListener("resize", update);

    return () => {
      ro.disconnect();
      window.removeEventListener("resize", update);
    };
  }, []);

  return rect;
}
